module.exports = __webpack_public_path__ + "static/media/features-bg.26f58031.png";